import appSettings from "../../settings/appSettings";
import { wvusLogger } from "../../helpers";

async function applePayMerchantValidation() {
  const subdomain = window.location.hostname.split(".")[0] || "www";
  const serviceUrl = `${appSettings.sentryApiConfig.baseUrl}/applepaymerchantvalidate?subdomain=${subdomain}`;
  const subscriptionKey = appSettings.sentryApiConfig.subscriptionKey;

  try {
    const response = await fetch(serviceUrl, {
      method: "GET",
      headers: {
        "Ocp-Apim-Subscription-Key": subscriptionKey,
        "Content-Type": "application/json"
      }
    });

    if (response.ok) {
      const data = await response.json();

      return { success: true, data };
    } else {
      const errorText = await response.text();
      wvusLogger.log(
        `Merchant validation failed with HTTP code: ${response.status}, ${errorText}`,
        wvusLogger.getLogLevelNames().ERROR
      );
      return {
        success: false,
        error: `Merchant validation failed with HTTP code ${response.status}`
      };
    }
  } catch (error) {
    wvusLogger.log(`Merchant validation failed: ${error}`, wvusLogger.getLogLevelNames().ERROR);
    return { success: false, error: `Merchant validation failed: ${error.message}` };
  }
}

export default applePayMerchantValidation;
export { applePayMerchantValidation };
